export const prettyList = (list: string[]) => {
  switch (list.length) {
    case 0:
      return '';
    case 1:
      return list[0];
    default: {
      const editableList = [...list];
      const last = editableList.pop();
      return `${editableList.join(', ')} and ${last}`;
    }
  }
};

export const mapEnum =
  <TEnum extends string>(map: Record<TEnum, string>) =>
  (value: TEnum) => {
    return map[value];
  };

export const mapEnums =
  <TEnum extends string>(map: Record<TEnum, string>) =>
  (enumValues: TEnum[]) => {
    const mappedValues = enumValues
      .map((value) => map[value] || null)
      .filter((value) => value !== null) as Array<string>;

    return prettyList(mappedValues);
  };

export const pluralise =
  ({
    none,
    single,
    plural,
  }: {
    none: string;
    single: string;
    plural: (count: number) => string;
  }) =>
  (count: number) => {
    switch (count) {
      case 0:
        return none;
      case 1:
        return single;
      default:
        return plural(count);
    }
  };
